export const Data = [
  {
    type: "zh",
    numList : [
      {
        num : 1,
        tital : "产品介绍",
        path: "aa"
      },
      {
        num : 2,
        tital : "工作尖",
        path: "aa"
      },
      {
        num : 3,
        tital : "手柄",
        path: "aa"
      }
    ]
  },
  {
    type: "en",
    numList : [
      {
        num : 1,
        tital : "产品介绍",
        path: "aa"
      },
      {
        num : 2,
        tital : "工作尖",
        path: "aa"
      },
      {
        num : 3,
        tital : "手柄",
        path: "aa"
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/components/js/image/mun2.js